import React from 'react';
import c from 'classnames';
import numeral from 'numeral';
import Countdown from '../Countdown';
import s from './AdoptableCountdown.scss';
const AdoptableCountdown = ({ countToDate, className, endedClassName, endedMessage, onEnd })=>/*#__PURE__*/ React.createElement(Countdown, {
        className: c(s['root'], className),
        endedClassName: c(s['ended'], endedClassName),
        countToDate: countToDate,
        renderTimer: (d, h, m, sec)=>[
                h + d * 24,
                m,
                sec
            ].map((n)=>numeral(n).format('00')).join(':'),
        endedMessage: endedMessage,
        onEnd: onEnd
    });
AdoptableCountdown.displayName = 'AdoptableCountdown';
export default AdoptableCountdown;

//# sourceMappingURL=AdoptableCountdown.js.map